import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { AddCompanyModalContainer } from './styled'
import r from 'reactotron-react-js'

const CompanyModal = (props) => {
  const { valueForm, handleSubmit, onSubmitCompanies, showCompanyModal, clearCompanyData } = props

  const submitCompanies = () => {
    onSubmitCompanies(valueForm)
    clearCompanyData()
    showCompanyModal(false)
  }

  return (
    <Dialog open={true} maxWidth='md' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Add Company</DialogTitle>
      <DialogContent>
        <form>
          <AddCompanyModalContainer>
            <div className='rowFields'>
              <Field name='bankCountry' label='Bank Country' require type={type.text} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field name='bankKey' label='Bank Key' require type={type.text} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field name='branch' label='Branch' require type={type.text} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field name='accountNumber' label='Account Number' require type={type.text} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field name='accountName' label='Account Name' require type={type.text} component={FieldInput} />
            </div>
          </AddCompanyModalContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form onSubmit={handleSubmit(values => submitCompanies())}>
          <Button
            color='blue'
            content='Add'
            type='submit'
          />
          <Button
            color='red'
            content='Cancel'
            onClick={() => showCompanyModal(false)}
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const companyData = props.companyData || {}
  return ({
    valueForm: getFormValues('formCompany')(state),
    initialValues: {
      companies: companyData.companies || []
    }
  })
}
  
const mapDispatchToProps = {
}

const CompanyModalForm = reduxForm({
  form: 'formCompany',
  enableReinitialize: true
})(CompanyModal)

export default connect(mapStateToProps, mapDispatchToProps)(CompanyModalForm)